/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { Map, MapInterface } from "../Map";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    name: "Map_BuildUnauthorized",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "Map_BuildingAlreadyExists",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "Map_BuildingDoesNotExist",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "Map_BuildingIsNotActive",
    type: "error",
  },
  {
    inputs: [],
    name: "Map_InvalidBuildingParams",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "prevBuildingRequired",
        type: "bytes32",
      },
    ],
    name: "Map_InvalidPrevBuilding",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "Map_LandBuildingDoesNotExist",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "Map_LandBuildingHasActiveRecipes",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    name: "Map_LandNotOwned",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "workersRequired",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "workersBalance",
        type: "uint256",
      },
    ],
    name: "Map_NotEnoughWorkers",
    type: "error",
  },
  {
    inputs: [],
    name: "Map_UnauthorizedWorkersMint",
    type: "error",
  },
  {
    inputs: [],
    name: "Ownable_NewOwnerCannotBeAddressZero",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Ownable_SenderIsNotOwner",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "BuildingActivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "BuildingAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "unlockAt",
        type: "uint256",
      },
    ],
    name: "BuildingBuilt",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "BuildingDeactivated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "BuildingDestroyed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "BuildingUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "to",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operatorAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newValue",
        type: "bool",
      },
    ],
    name: "OperatorToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "activateBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint96",
        name: "workersRequired",
        type: "uint96",
      },
      {
        internalType: "uint40",
        name: "buildDuration",
        type: "uint40",
      },
      {
        internalType: "bytes32",
        name: "prevBuildingRequired",
        type: "bytes32",
      },
    ],
    name: "addBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    name: "balanceOfWithLocked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "replaceId",
        type: "uint256",
      },
    ],
    name: "build",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "buildAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "deactivateBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
    ],
    name: "destroy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
    ],
    name: "destroyAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAdmin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "getBuilding",
    outputs: [
      {
        components: [
          {
            internalType: "uint40",
            name: "buildDuration",
            type: "uint40",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "uint96",
            name: "workersRequired",
            type: "uint96",
          },
          {
            internalType: "bytes32",
            name: "prevBuildingRequired",
            type: "bytes32",
          },
        ],
        internalType: "struct IMap.Building",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCraft",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLand",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "getLandBuilding",
    outputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "destroyed",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "unlockAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "getLandBuildingsHashes",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "landBuildingHashes",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    name: "getLandBuildingsHashesLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "isBuilding",
    outputs: [
      {
        internalType: "bool",
        name: "result",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "isBuildingActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "isLandBuildingAvailable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isOperator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintWorkers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newCraft",
        type: "address",
      },
    ],
    name: "setCraft",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newLand",
        type: "address",
      },
    ],
    name: "setLand",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operatorAddress",
        type: "address",
      },
    ],
    name: "toggleOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint96",
        name: "workersRequired",
        type: "uint96",
      },
      {
        internalType: "uint40",
        name: "buildDuration",
        type: "uint40",
      },
      {
        internalType: "bytes32",
        name: "prevBuildingRequired",
        type: "bytes32",
      },
    ],
    name: "updateBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class Map__factory {
  static readonly abi = _abi;
  static createInterface(): MapInterface {
    return new Interface(_abi) as MapInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Map {
    return new Contract(address, _abi, runner) as unknown as Map;
  }
}
